// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"e477b041","319":"7f769fbf","453":"abdbefcb","740":"9bad8540","950":"fc1570e5"}[chunkId] + ".chunk.js";
};